var scrollPositions = {} ;
module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){

            var wrapper = document.querySelector(".main-views-wrapper");

            if(wrapper){
                if(context.previousPosition){
                    scrollPositions[context.previousPosition] = wrapper.scrollTop ;
                }
                var newScrollTop = scrollPositions[context.currentPosition] || 0 ;
                //console.log(context, wrapper.scrollTop, scrollPositions, newScrollTop) ;
                wrapper.scrollTop = newScrollTop ;
            }

            next() ;
        }
    }
];